import ukwebconfig from '@cof/ukweb-config/lib/clientConfig';

type OrchestrationEndpoint = keyof ReturnType<typeof ukwebconfig.get<'orchestration'>>;

const getConfig = (endpoint: OrchestrationEndpoint) => {
    const config = ukwebconfig.get('orchestration')[endpoint];

    return {
        ...config,
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
        }
    };
};

export default getConfig;
